import React, { FC } from 'react'
import { cn } from 'shared/utils'

import { IProjectCreateHelperProps } from './ProjectCreateHelper.props'
import './ProjectCreateHelper.scss'

const ProjectCreateHelper: FC<IProjectCreateHelperProps> = ({ className = '', children, dark }) => (
  <div className={cn(className, 'project-create-helper', { 'project-create-helper--dark': dark })}>
    {children}
  </div>
)

export default ProjectCreateHelper
